import { always } from "../../../base/utils/ramdaEquivalents.utils";
import { makeObservableRouteDef } from "../../../base/utils/routes.utils";
import PageVerifyEmail from "./VerifyEmail.page";

export const VerifyEmailPageRoute = makeObservableRouteDef({
  identifier: 'verify-email',
  urlFactory: always('verify-email'),
  composeTitle: always('Verify Email'),
  component: PageVerifyEmail,
})